<template>
    <div >

                <h1 style="text-align: center;padding:50px 0">创建于1990</h1>
                <el-timeline :reverse="reverse" class="timeline" style="">
                    <el-timeline-item
                            v-for="(activity, index) in yearsList"
                            :key="index"
                            :timestamp="activity.timestamp"
                            size="large"
                            color="#0bbd87"
                            :class="index % 2 !=0?'out':''"
                            :type="activity.type"
                            placement="top"
                    >
                        <p>{{activity.content}}</p>
                        <div style="padding: 10px" v-show="activity.img !=''">
                            <img :src="activity.img" alt="" style="width: 300px;height: auto">
                        </div>

                    </el-timeline-item>
                </el-timeline>


    </div>
</template>

<script>
    import request from "@/utils/request";

    export default {
        name: "DevelopmentIntroduce",
        data(){
            return{
                reverse: true,
                yearsList:[],


            }
        },
        mounted() {
            let that =this
            request.get("/about/zh").then(res =>{

                for (let i = 0; i <res.data.yearsList.length ; i++) {
                    console.log(res.data.yearsList[i].img);
                    let timestamps={
                        content:res.data.yearsList[i].value,
                        timestamp:res.data.yearsList[i].year,
                        img:res.data.yearsList[i].img
                    }
                    that.yearsList.push(timestamps)
                }

            }).catch((res)=>{
            })
        }
    }
</script>

<style scoped>

    @media screen and (min-width: 768px) {
        .timeline {
            padding-left: 50vw;
        }


        >>> .el-timeline-item {
            height: auto;
        }


        >>> .el-timeline-item__timestamp {
            font-size: 2rem !important;
            color: #004ea2 !important;
            font-weight: bolder !important;
            font-family: SimHei !important;
        }

        >>> .el-timeline-item__content {
            line-height: 1.5rem !important;
            font-size: 1.1rem;
        }

        h1 {
            opacity: 0;
            animation: moveUp 2s ease-in-out forwards;
        }

        .out >>> .el-timeline-item__wrapper {

            left: calc(-30vw - 100px);
            opacity: 0;
            text-align: right;
            animation: moveLeft 2s ease-in-out forwards;

        }

        >>> .el-timeline-item__wrapper {
            opacity: 0;
            padding-left: 100px !important;
            width: 30vw;
            animation: moveRight 2s ease-in-out forwards;
        }
    }


    @media screen and (max-width: 768px){
        .timeline{
            padding-left: 25px;
        }

        >>> .el-timeline-item {
            height: 100px;
        }

        >>> .el-timeline-item__timestamp{
            color: #004ea2 !important;
            font-family: HarmonyOS_Sans_SC_Bold;
        }


        >>>.el-timeline-item__wrapper{
            padding: 0 20px;
            opacity: 0;
            text-align: left;
            animation: moveRight 2s ease-in-out forwards;
        }
    }


    >>>.el-timeline-item:nth-child(1) .el-timeline-item__wrapper  {

        animation-delay: 0.5s;
    }
    >>>.el-timeline-item:nth-child(2) .el-timeline-item__wrapper  {
        animation-delay: 1s;
    }
    >>>.el-timeline-item:nth-child(3) .el-timeline-item__wrapper  {

        animation-delay: 1.5s;
    }
    >>>.el-timeline-item:nth-child(4) .el-timeline-item__wrapper  {
        animation-delay: 2s;
    }
    >>>.el-timeline-item:nth-child(5) .el-timeline-item__wrapper  {

        animation-delay: 2.5s;
    }
    >>>.el-timeline-item:nth-child(6) .el-timeline-item__wrapper  {
        animation-delay: 3s;
    }
    >>>.el-timeline-item:nth-child(7) .el-timeline-item__wrapper  {

        animation-delay: 3.5s;
    }
    >>>.el-timeline-item:nth-child(8) .el-timeline-item__wrapper  {
        animation-delay: 4s;
    }
    >>>.el-timeline-item:nth-child(9) .el-timeline-item__wrapper  {

        animation-delay: 4.5s;
    }
    >>>.el-timeline-item:nth-child(10) .el-timeline-item__wrapper  {
        animation-delay: 5s;
    }
    >>>.el-timeline-item:nth-child(11) .el-timeline-item__wrapper  {

        animation-delay: 5.5s;
    }
    >>>.el-timeline-item:nth-child(12) .el-timeline-item__wrapper  {
        animation-delay: 6s;
    }
    >>>.el-timeline-item:nth-child(13) .el-timeline-item__wrapper  {
        animation-delay: 6.5s;
    }
    >>>.el-timeline-item:nth-child(14) .el-timeline-item__wrapper  {
        animation-delay: 7s;
    }
    >>>.el-timeline-item:nth-child(15) .el-timeline-item__wrapper  {
        animation-delay: 7.5s;
    }
    >>>.el-timeline-item:nth-child(16) .el-timeline-item__wrapper  {
        animation-delay: 8s;
    }
    >>>.el-timeline-item:nth-child(17) .el-timeline-item__wrapper  {
        animation-delay: 8.5s;
    }
    >>>.el-timeline-item:nth-child(18) .el-timeline-item__wrapper  {
        animation-delay: 9s;
    }
    >>>.el-timeline-item:nth-child(19) .el-timeline-item__wrapper  {
        animation-delay: 9.5s;
    }
</style>